export default __webpack_public_path__ + "static/media/dropdown.feb28327.svg";